/**
 * Observes a component for intersection with the viewport, and triggers the binding function
 * when an element is viewed for 5 seconds.
 **/
const ViewTime = {
  mounted(el, binding) {
    let timeout = null;
    
    el._viewtime = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting && entry.intersectionRect && entry.intersectionRect.height) {
          timeout = setTimeout(binding.value, 5000);
        } else if(timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    });

    el._viewtime.observe(el);
  },
  beforeUnmount(el) {
    if(el && el._viewtime) {
      el._viewtime.unobserve(el);
    }
  }
}

export default ViewTime;